import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('helmet-buyer-guide-landing', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./helmet-buyer-guide-landing')
        ),
);
